// @ts-nocheck

import { Container } from '../../Container/Container';
import { getProduct } from '../../../api/product/getProduct';
import { getDocumentUrl } from '../../../api/document/getDocumentUrl';
import { pdfjs } from 'react-pdf';
import { getPartStatus } from '../../../api/part/getPart';
import { TextItem } from 'pdfjs-dist/types/src/display/api';
import { useState, useRef } from 'react';
import pLimit from 'p-limit';
import React from 'react';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

const ScriptPage = () => {
  const [allProducts, setAllProducts] = useState(0);
  const [allProductsID, setAllProductsID] = useState([]);
  const [currentProduct, setCurrentProduct] = useState(0);
  const stopRef = useRef(false);

  // Переменные для хранения результатов и прогресса
  const resultArrRef = useRef<any[]>([]);
  const resultproductsArrRef = useRef<any>({ products: [] });
  const withoutExplodedViewRef = useRef(0);
  const successProductsRef = useRef(0);
  const unsuccessfulProductsRef = useRef(0);
  const errorProductsRef = useRef<any[]>([]);

  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  // Разбиение массива на батчи
  const chunkArray = (array: any[], size: number) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  // Функция для скачивания результатов
  const downloadResults = (results: any) => {
    const jsonStr = JSON.stringify(results, null, 2);
    const blob = new Blob([jsonStr], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'results.json';
    a.click();
    URL.revokeObjectURL(url);
  };

  // Функция для генерации результатов
  const generateResults = () => {
    resultArrRef.current.unshift({
      withoutExplodedView: withoutExplodedViewRef.current,
      successProducts: successProductsRef.current,
      unsuccessfulProducts: unsuccessfulProductsRef.current,
      errorProducts: errorProductsRef.current.length,
    });
    resultArrRef.current.push(resultproductsArrRef.current);
    resultArrRef.current.push({ errors: errorProductsRef.current });
    downloadResults(resultArrRef.current);
  };

  // Основная функция анализа
  const analizeFunc = async (arr?: any[]) => {
    stopRef.current = false;
    resultArrRef.current = [];

    const mainArr = arr.length ? arr : allProductsID;
    // Если массив передан (через загрузку файла), используем его
    setAllProducts(mainArr.length);

    // Текущий индекс для продолжения
    let currentIndex = arr ? 0 : currentProduct;

    for (; currentIndex < mainArr.length; currentIndex++) {
      if (stopRef.current) {
        // Перед остановкой сохраняем прогресс
        return;
      }

      setCurrentProduct(currentIndex + 1);
      const productID = mainArr[currentIndex];

      try {
        await sleep(10);
        const product = await getProduct(productID);
        if (!product) continue;

        if (!product.explodedViews?.s3Key || !product.explodedViews?.s3Bucket) {
          withoutExplodedViewRef.current++;
          continue;
        }

        const explodedView = await getDocumentUrl(
          product.explodedViews.s3Bucket,
          product.explodedViews.s3Key,
        );

        if (!explodedView?.url) continue;

        const pdfDoc = await pdfjs.getDocument(explodedView.url).promise;
        const numPages = pdfDoc.numPages;

        const allPartsInDocument: string[] = [];

        for (let i = 1; i <= numPages; i++) {
          const page = await pdfDoc.getPage(i);
          const textContent = await page.getTextContent();
          for (const item of textContent.items) {
            const str = (item as TextItem).str;
            if (str.length < 6) continue;
            allPartsInDocument.push(str);
          }
        }

        const partsArr: string[] = [];
        const partsBatches = chunkArray(allPartsInDocument, 5);
        const limit = pLimit(5);

        for (const batch of partsBatches) {
          const batchPromises = batch.map((partCode: string) =>
            limit(async () => {
              const status = await getPartStatus(partCode);
              return { partCode, status };
            }),
          );
          const batchResults = await Promise.all(batchPromises);
          for (const res of batchResults) {
            if (res.status === 500) {
              throw new Error(
                `partCode - ${res.partCode} return status 500 and "Multiple parts found for the given ID" message`,
              );
            }
            if (res.status === 404) continue;
            const index = product.parts?.findIndex(
              (part) => part.displayData.partCode === res.partCode,
            );
            if (index !== -1) continue;
            else partsArr.push(res.partCode);
          }
          // await sleep(1000); // задержка между батчами
        }

        if (partsArr.length) {
          unsuccessfulProductsRef.current++;
          resultproductsArrRef.current.products.push({ [productID]: partsArr });
        } else {
          successProductsRef.current++;
        }
      } catch (err) {
        if (err.status === 429) await sleep(1000);
        errorProductsRef.current.push({ [productID]: err });
      }
    }

    generateResults();
  };

  // Обработчик загрузки файла
  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setCurrentProduct(0);
    resultArrRef.current = [];
    resultproductsArrRef.current = { products: [] };
    withoutExplodedViewRef.current = 0;
    successProductsRef.current = 0;
    unsuccessfulProductsRef.current = 0;
    errorProductsRef.current = [];
    try {
      const text = await file.text(); // читаем содержимое файла
      const data = JSON.parse(text); // парсим JSON
      if (Array.isArray(data)) {
        setAllProductsID(data);
        await analizeFunc(data); // запускаем анализ с загруженным массивом
      } else {
        console.error('Загруженный файл не является массивом');
      }
    } catch (error) {
      console.error('Ошибка при обработке файла:', error);
    }
  };

  return (
    <Container>
      {/* Добавляем элемент выбора файла */}
      <div style={{ marginBottom: '16px', marginTop: '48px' }}>
        <input type="file" accept=".json" onChange={handleFileChange} />
      </div>
      {/* Остальной интерфейс */}
      <div>
        <span>
          {currentProduct} / {allProducts}
        </span>
      </div>
      <button onClick={analizeFunc}>Start</button>
      <button
        style={{ marginLeft: '24px' }}
        onClick={() => {
          stopRef.current = true;
          generateResults();
        }}
      >
        Stop
      </button>
    </Container>
  );
};

export default ScriptPage;
